import { hasAnyPermissions } from 'lib/functions/utils';
import { User } from 'services/redux/authSlice';

export function hasAnySettingsUsersPermissions(user: User | undefined) {
  return hasAnyPermissions(user, [
    'settings',
    'settings_users',
    'users_create_new',
  ]);
}

export function hasAnySettingsProductsPermissions(user: User | undefined) {
  return hasAnyPermissions(user, ['settings', 'settings_products']);
}

export function hasAnySettingsRiskPermissions(user: User | undefined) {
  return hasAnyPermissions(user, [
    'settings',
    'settings_risk',
    'settings_risk_blacklist_view',
  ]);
}

export function hasAnySettingsFinancePermissions(user: User | undefined) {
  return hasAnyPermissions(user, [
    'settings',
    'settings_finance',
    'settings_collections',
    'settings_funds',
    'settings_pending_accounts',
  ]);
}

export function hasAnySettingsSiiPermissions(user: User | undefined) {
  return hasAnyPermissions(user, ['settings', 'settings_sii']);
}

export function hasAnySettingsTagsPermissions(user: User | undefined) {
  return hasAnyPermissions(user, ['settings', 'settings_tags']);
}

export function hasAnySettingsAccountingPermissions(user: User | undefined) {
  return hasAnyPermissions(user, ['settings', 'settings_accounting']);
}

export function hasAnySettingsContractsPermissions(_user: User | undefined) {
  // return hasAnyPermissions(user, []);
  return true;
}

export function hasAnySettingsPermissions(user: User | undefined) {
  return (
    hasAnyPermissions(user, ['settings']) ||
    hasAnySettingsUsersPermissions(user) ||
    hasAnySettingsProductsPermissions(user) ||
    hasAnySettingsRiskPermissions(user) ||
    hasAnySettingsFinancePermissions(user) ||
    hasAnySettingsSiiPermissions(user) ||
    hasAnySettingsTagsPermissions(user) ||
    hasAnySettingsAccountingPermissions(user) ||
    hasAnySettingsContractsPermissions(user)
  );
}
